const hostname= window.location.hostname;
// const hostname= 'dev.app.zaap.ai';
let appUrlCheck=""
let apiUrlCheck= ""
let pageUrlCheck= ""
let protocolCheck= ""

let hosts = process.env.REACT_APP_HOSTNAME_PROD;
hosts = hosts.split(',');

if(hostname == (process.env.REACT_APP_HOSTNAME_LOCAL)){
    appUrlCheck = process.env.REACT_APP_URL_LOCAL;
    apiUrlCheck = process.env.REACT_APP_BACKEND_URL_LOCAL;
    pageUrlCheck = process.env.REACT_APP_PAGE_HOSTNAME_LOCAL;
    protocolCheck = process.env.REACT_APP_PAGE_PROTOCOL_LOCAL;
}
else if(hostname == (process.env.REACT_APP_HOSTNAME_DEV)){
    appUrlCheck = process.env.REACT_APP_URL_DEV;
    apiUrlCheck = process.env.REACT_APP_BACKEND_URL_DEV;
    pageUrlCheck = process.env.REACT_APP_PAGE_HOSTNAME_DEV;
    protocolCheck = process.env.REACT_APP_PAGE_PROTOCOL_DEV;
}
else if(hosts.includes(hostname)){
    appUrlCheck = process.env.REACT_APP_PAGE_PROTOCOL_PROD + process.env.hostname;
    apiUrlCheck = process.env.REACT_APP_BACKEND_URL_PROD;
    pageUrlCheck = process.env.REACT_APP_PAGE_PROTOCOL_PROD + process.env.hostname;
    protocolCheck = process.env.REACT_APP_PAGE_PROTOCOL_PROD;
}

export const appUrl = appUrlCheck;
export const apiUrl = apiUrlCheck;
export const pageUrl = pageUrlCheck;
export const protocol = protocolCheck;